import styled from 'styled-components';

export default styled.div.attrs({ className: 'inner' })`
  width: 1rem;
  height: 1rem;
  border-radius: 1rem;
  justify-self: center;
  align-self: center;
`;
